import Vue from 'vue';
import ApiRequest from '@/tools/ApiRequest';
import RequestException from '@/tools/helpers/RequestException';

export default Vue.extend({
  name: 'winners',
  data: () => ({
    winners: [] as { number: string; client: string }[],
  }),
  created(): void {
    ApiRequest.getWinners()
      .then((response) => {
        if (response.data.length > 0) {
          this.winners = response.data;
        } else {
          this.$router.push('/');
        }
      })
      .catch((error) => new RequestException(error, this.$store, this.$router));
  },
});
